import React from "react";
import { Outlet } from "react-router-dom";
// import Sidebar from "../../Sidebar";
import Header from "../../Screens/dashboard/header";
import Footer from "../../Screens/dashboard/footer";
const Layout = () =>{
    const token = localStorage.getItem("able-auctions");

    return(
        <>
        <div className={token && "wrapper-active"} id="wrapper">
            {/* {token && <Sidebar/>} */}
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    {token && <Header authData={token}/>}
                    <div>
                        <Outlet/>
                    </div>
                    {token && <Footer/>}
                </div>
            </div>
        </div>
        </>
    );
}


export default Layout;


